import * as STD        from '@emersya/mpa-std-lib';
import CM              from '@emersya/mpa-components-manager-lib';
import { InputButton } from '@emersya/mpa-components-lib';

export interface StandingHangingSignConfiguratorTileConfiguration extends InputButton.Configuration {
};

export class StandingHangingSignCustomConfiguratorTileComponent extends InputButton.Component {
	static override initialize() {
		super.initialize();
	};

	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : StandingHangingSignConfiguratorTileConfiguration
	)
	{
		// configuration['@innerConfigurations'] = {
		// 	titleContainer : {
		// 		'@innerConfigurations' : {
		// 			title : {
		// 				'@translations' : {
		// 					text : {
		// 						'en' : 'titre',
		// 						'fr' : 'Non'
		// 					}
		// 				}
		// 			},
		// 			subtitle : {
		// 				'@translations' : {
		// 					text : {
		// 						'en' : 'sous titre',
		// 						'fr' : 'Non'
		// 					}
		// 				}
		// 			}
		// 		}
		// 	}
		// };
		super(descriptor, configuration);
	};
};

import manifestXMLSource from './StandingHangingSignCustomConfiguratorTile.xml';
import './StandingHangingSignCustomConfiguratorTile.scss';

export namespace NS {
	export const Component = StandingHangingSignCustomConfiguratorTileComponent;
	export type Component = StandingHangingSignCustomConfiguratorTileComponent;
	export type Configuration = StandingHangingSignConfiguratorTileConfiguration;
}

CM.declare({
	id :       'standing-hangingSignCustomConfiguratorTile',
	type :     StandingHangingSignCustomConfiguratorTileComponent,
	manifest : manifestXMLSource
});
